import * as React from 'react'
const LMHighestPeak = () => (
  <svg
    width={33}
    height={33}
    viewBox="0 0 11.150768 7.3356361"
    fill="currentColor"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g id="layer1" transform="translate(-112.13064,-145.94941)">
      <rect
        style={{
          display: "none",
          fill: "#280b0b",
          stroke: "#ffffff",
          strokeWidth: 0.529167,
          strokeLinejoin: "round",
        }}
        id="rect9"
        width={209.38908}
        height={297.40347}
        x={-0.35489929}
        y={-12.06649}
      />
      <g id="g131" transform="translate(0,0.8872419)">
        <g
          id="g132"
          transform="matrix(0.17392017,0,0,0.19091518,69.554023,140.54085)"
        >
          <g id="g124" transform="translate(214.40426,-11.696845)">
            <g
              id="g121"
              style={{
                display: "inline",
              }}
            >
              <path
                id="path120"
                style={{
                  fill: "var(--primary)",
                  fillOpacity: 1,
                  strokeWidth: 0.342223,
                }}
                d="m 52.318228,49.212776 -3.470076,4.423497 a 0.78796886,0.78796886 175.74805 0 1 -1.161206,0.08633 l -3.062042,-2.893926 a 0.6748548,0.6748548 171.69076 0 0 -1.047992,0.153058 L 40.932385,55.5625 30.401245,73.80273 H 52.902197 75.403149 L 64.872009,55.5625 62.286166,51.083388 a 0.76757667,0.76757667 8.3092435 0 0 -1.191981,-0.174087 l -2.964717,2.801945 a 0.80305141,0.80305141 4.2519501 0 1 -1.183433,-0.08799 l -3.459869,-4.410485 a 0.74221132,0.74221132 -180 0 0 -1.167938,0 z"
              />
              <path
                id="path121"
                style={{
                  fill: "var(--accent)",
                  fillOpacity: 1,
                  strokeWidth: 0.342223,
                }}
                d="m 52.426081,35.654087 -6.84075,11.848957 2.226254,2.104024 a 0.63156469,0.63156469 175.74804 0 0 0.930717,-0.0692 l 3.759327,-4.79222 a 0.50911319,0.50911319 0 0 1 0.801136,0 l 3.786181,4.826453 a 0.59188441,0.59188441 4.251957 0 0 0.872242,0.06485 l 2.257875,-2.13391 -6.84075,-11.848957 a 0.54976677,0.54976677 0 0 0 -0.952232,0 z"
              />
            </g>
            <g
              id="g123"
              transform="matrix(0.74266227,0,0,0.74266227,38.516459,18.992227)"
              style={{
                display: "inline",
              }}
            >
              <path
                id="path122"
                style={{
                  fill: "var(--primary)",
                  fillOpacity: 1,
                  strokeWidth: 0.342223,
                }}
                d="m 52.318228,49.212776 -3.470076,4.423497 a 0.78796886,0.78796886 175.74805 0 1 -1.161206,0.08633 l -3.062042,-2.893926 a 0.6748548,0.6748548 171.69076 0 0 -1.047992,0.153058 L 40.932385,55.5625 30.401245,73.80273 H 52.902197 75.403149 L 64.872009,55.5625 62.286166,51.083388 a 0.76757667,0.76757667 8.3092435 0 0 -1.191981,-0.174087 l -2.964717,2.801945 a 0.80305141,0.80305141 4.2519501 0 1 -1.183433,-0.08799 l -3.459869,-4.410485 a 0.74221132,0.74221132 -180 0 0 -1.167938,0 z"
              />
              <path
                id="path123"
                style={{
                  fill: "var(--accent)",
                  fillOpacity: 1,
                  strokeWidth: 0.342223,
                }}
                d="m 52.426081,35.654087 -6.84075,11.848957 2.226254,2.104024 a 0.63156469,0.63156469 175.74804 0 0 0.930717,-0.0692 l 3.759327,-4.79222 a 0.50911319,0.50911319 0 0 1 0.801136,0 l 3.786181,4.826453 a 0.59188441,0.59188441 4.251957 0 0 0.872242,0.06485 l 2.257875,-2.13391 -6.84075,-11.848957 a 0.54976677,0.54976677 0 0 0 -0.952232,0 z"
              />
            </g>
          </g>
          <path
            id="path124"
            style={{
              fill: "#ffffff",
              fillOpacity: 1,
              strokeWidth: 0.76,
            }}
            d="m 283.75787,47.8007 -1.10846,1.919779 7.15047,12.385291 h 2.14147 z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default LMHighestPeak
